import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { AccountRetrievalGenerateOTPUseCase } from './AccountRetrievalGenerateOTPUseCase';
import { AccountRetrievalVerifyOTPUseCase } from './AccountRetrievalVerifyOTPUseCase';
import { AddFavoriteChannelsUseCase } from './AddFavoriteChannelsUseCase';
import { AddProfileUseCase } from './AddProfileUseCase';
import { AddWatchlistUseCase } from './AddWatchlistUseCase';
import { CreateParentalLockUseCase } from './CreateParentalLockUseCase';
import { DeleteFavoriteChannelsUseCase } from './DeleteFavoriteChannelsUseCase';
import { DeleteProfileUseCase } from './DeleteProfileUseCase';
import { DeleteWatchlistUseCase } from './DeleteWatchlistUseCase';
import { GetFavoriteChannelsUseCase } from './GetFavoriteChannelsUseCase';
import { GetParentalLockUseCase } from './GetParentalLockUseCase';
import { GetProfilesUseCase } from './GetProfilesUseCase';
import { GetWatchlistUseCase } from './GetWatchlistUseCase';
import { SwitchProfileUseCase } from './SwitchProfileUseCase';
import { UpdateParentalLockUseCase } from './UpdateParentalLockUseCase';
import { UpdateProfileUseCase } from './UpdateProfileUseCase';
import { ValidateParentalLockUseCase } from './ValidateParentalLockUseCase';
import { ValidatePasswordUseCase } from './ValidatePasswordUseCase';
import { AccountB2CRetrievalGenerateOTPUseCase } from './AccountB2CRetrievalGenerateOTPUseCase';
import { AccountB2CRetrievalVerifyOTPUseCase } from './AccountB2CRetrievalVerifyOTPUseCase';
import { ResetParentalLockOTPUseCase } from './ResetParentalLockOTPUseCase';

export const initializeProfileUseCases = (container: Container) => {
    container.register(DI.USECASES.IAccountRetrievalGenerateOTPUseCase, {
        useClass: AccountRetrievalGenerateOTPUseCase,
    });
    container.register(DI.USECASES.IAccountRetrievalVerifyOTPUseCase, {
        useClass: AccountRetrievalVerifyOTPUseCase,
    });
    container.register(DI.USECASES.IAccountB2CRetrievalGenerateOTPUseCase, {
        useClass: AccountB2CRetrievalGenerateOTPUseCase,
    });
    container.register(DI.USECASES.IAccountB2CRetrievalVerifyOTPUseCase, {
        useClass: AccountB2CRetrievalVerifyOTPUseCase,
    });
    container.register(DI.USECASES.IAddFavoriteChannelsUseCase, {
        useClass: AddFavoriteChannelsUseCase,
    });
    container.register(DI.USECASES.IAddProfileUseCase, {
        useClass: AddProfileUseCase,
    });
    container.register(DI.USECASES.IAddWatchlistUseCase, {
        useClass: AddWatchlistUseCase,
    });
    container.register(DI.USECASES.ICreateParentalLockUseCase, {
        useClass: CreateParentalLockUseCase,
    });
    container.register(DI.USECASES.IDeleteFavoriteChannelsUseCase, {
        useClass: DeleteFavoriteChannelsUseCase,
    });
    container.register(DI.USECASES.IDeleteProfileUseCase, {
        useClass: DeleteProfileUseCase,
    });
    container.register(DI.USECASES.IDeleteWatchlistUseCase, {
        useClass: DeleteWatchlistUseCase,
    });
    container.register(DI.USECASES.IGetFavoriteChannelsUseCase, {
        useClass: GetFavoriteChannelsUseCase,
    });
    container.register(DI.USECASES.IGetParentalLockUseCase, {
        useClass: GetParentalLockUseCase,
    });
    container.register(DI.USECASES.IGetProfilesUseCase, {
        useClass: GetProfilesUseCase,
    });
    container.register(DI.USECASES.IGetWatchlistUseCase, {
        useClass: GetWatchlistUseCase,
    });
    container.register(DI.USECASES.ISwitchProfileUseCase, {
        useClass: SwitchProfileUseCase,
    });
    container.register(DI.USECASES.IUpdateParentalLockUseCase, {
        useClass: UpdateParentalLockUseCase,
    });
    container.register(DI.USECASES.IResetParentalLockOTPUseCase, {
        useClass: ResetParentalLockOTPUseCase,
    });
    container.register(DI.USECASES.IUpdateProfileUseCase, {
        useClass: UpdateProfileUseCase,
    });
    container.register(DI.USECASES.IValidateParentalLockUseCase, {
        useClass: ValidateParentalLockUseCase,
    });
    container.register(DI.USECASES.IValidatePasswordUseCase, {
        useClass: ValidatePasswordUseCase,
    });
};
